/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Precheck_AbortInputs */

const en_embed_captions_precheck_abort = /** @type {(inputs: Embed_Captions_Precheck_AbortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abort`)
};

const fr_embed_captions_precheck_abort = /** @type {(inputs: Embed_Captions_Precheck_AbortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abandonner`)
};

const de_embed_captions_precheck_abort = /** @type {(inputs: Embed_Captions_Precheck_AbortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbrechen`)
};

const it_embed_captions_precheck_abort = /** @type {(inputs: Embed_Captions_Precheck_AbortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aborto`)
};

const ru_embed_captions_precheck_abort = /** @type {(inputs: Embed_Captions_Precheck_AbortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отмена`)
};

const es_embed_captions_precheck_abort = /** @type {(inputs: Embed_Captions_Precheck_AbortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abortar`)
};

const zh_cn2_embed_captions_precheck_abort = /** @type {(inputs: Embed_Captions_Precheck_AbortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中止`)
};

const ja_embed_captions_precheck_abort = /** @type {(inputs: Embed_Captions_Precheck_AbortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アボート`)
};

const hi_embed_captions_precheck_abort = /** @type {(inputs: Embed_Captions_Precheck_AbortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बीच में बंद करें`)
};

const pt_pt2_embed_captions_precheck_abort = /** @type {(inputs: Embed_Captions_Precheck_AbortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abortar`)
};

/**
* | output |
* | --- |
* | "Abort" |
*
* @param {Embed_Captions_Precheck_AbortInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_precheck_abort = /** @type {((inputs?: Embed_Captions_Precheck_AbortInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Precheck_AbortInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_precheck_abort(inputs)
	if (locale === "de") return de_embed_captions_precheck_abort(inputs)
	if (locale === "it") return it_embed_captions_precheck_abort(inputs)
	if (locale === "ru") return ru_embed_captions_precheck_abort(inputs)
	if (locale === "es") return es_embed_captions_precheck_abort(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_precheck_abort(inputs)
	if (locale === "ja") return ja_embed_captions_precheck_abort(inputs)
	if (locale === "hi") return hi_embed_captions_precheck_abort(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_precheck_abort(inputs)
	return en_embed_captions_precheck_abort(inputs)
});